import * as React from 'react';

import { IMapElement } from '..';
import { Marker, Popup } from 'react-leaflet';
import { ClusterIcon } from './svg-icons/ClusterIcon';
import { MarkerIcon } from './svg-icons/MarkerIcon';
import { Gradient } from '../../helpers';

interface IProps {
  /**
   * Gradient to user for cluster coloring.
   */
  gradient: Gradient;
  /** 
   * Map element: must contain latitude, longitude, and optional count.
   * A map element that has a count will be shown as a cluster.
   */
  data: IMapElement;
  /**
   * Color of ordinary marker. Must be color name or rgb().
   * Uses default color if not specified.
   */
  markerColor?: string;
  /**
   * Callback that should return popup content for this marker.
   */
  popup: (item: IMapElement) => React.ReactNode;
}

const MARKER_COLOR = 'white';  // Default color of ordinary marker
const MARKER_SIZE = 25;        // Size of ordinary marker in px
const CLUSTER_SIZE = 42;       // Smallest cluster size in px
const CLUSTER_SIZE_STEP = 16;  // Cluster growth in px for each size level

/**
 * A ClusteredMarker takes an IMapElement. If this map element has a count,
 * then the marker will be a cluster marked. If it has no count, then it 
 * will be an ordinary marker.
 */
class ClusteredMarker extends React.Component<IProps> {
  render = () => {
    const p = this.props;
    const position: L.LatLngExpression = [p.data.latitude, p.data.longitude];
    if(p.data.count) {
      const logSize = Math.log10(p.data.count); // 0..10,000,000 => 0..7
      const color = p.gradient.getColor(logSize / 7);
      const size = logSize * CLUSTER_SIZE_STEP + CLUSTER_SIZE;
      return (
        <Marker position={position} icon={ClusterIcon(p.data.count, size, color)}/>
      );
    } else {
      return (
        <Marker position={position} icon={MarkerIcon(MARKER_SIZE, p.markerColor ? p.markerColor : MARKER_COLOR)}>
          <Popup minWidth={400} maxWidth={400}>
            {p.popup(p.data)}
          </Popup>
        </Marker>);
    }    
  }
}

export { ClusteredMarker }
